<template>
    <div class="ibox" :class="{'d-n': closed}">
        <div class="ibox-title">
            <h5>{{ title }} <small class="m-l-sm" v-if="subtitle">{{ subtitle }}</small></h5>
            <div class="ibox-tools">
                <a class="collapse-link" @click="toggleCollapse">
                    <i class="fa" :class="collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
                </a>
                <a class="dropdown-toggle" data-toggle="dropdown" href="#" v-if="hasConfig">
                    <i class="fa fa-wrench"></i>
                </a>
                <ul class="dropdown-menu dropdown-user" v-if="hasConfig">
                    <li v-for="(option, index) in configOptions" :key="index">
                        <a href="#" class="dropdown-item" @click.prevent="onConfigSelect(option)">{{ option.label }}</a>
                    </li>
                </ul>
                    <a class="close-link" @click="onClose" v-if="closable">
                    <i class="fa fa-times"></i>
                </a>
            </div>
        </div>
        <div class="ibox-content" v-show="!collapsed">
            <div class="sk-plane" v-if="!isLoaded"></div>
            <slot v-if="isLoaded"></slot>
        </div>
        <div class="ibox-footer" v-if="hasFooter && !collapsed">
            <span class="float-right" v-if="footerRight">
                {{ footerRight }}
            </span>

            {{ footerText }}
        </div>
    </div>
</template>
  
<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      subtitle: {
        type: String,
        default: ''
      },
      hasConfig: {
        type: Boolean,
        default: false
      },
      configOptions: {
        type: Array,
        default: () => []
      },
      closable: {
        type: Boolean,
        default: true
      },
      hasFooter: {
        type: Boolean,
        default: false
      },
      footerText: {
        type: String,
        default: ''
      },
      footerRight: {
        type: String,
        default: ''
      }
    },
    
    data() {
      return {
        isLoaded: true,
        collapsed: false,
        closed: false
      }
    },
    
    methods: {
      updateLoaded(loaded) {
        this.isLoaded = loaded;
      },
      
      toggleCollapse() {
        this.collapsed = !this.collapsed;
        this.$emit('collapse-toggled', this.collapsed);
      },
      
      onClose() {
        this.closed = true;
        this.$emit('close');
      },
      
      onConfigSelect(option) {
        this.$emit('config-selected', option);
      }
    }
  }
</script>